/**
 * 创建Worker池
 */
class FJWorkerPool {
    constructor(workerScript, onTaskComplete, onAllTasksComplete, poolSize = navigator.hardwareConcurrency - 2) {
        this.workerScript = workerScript; // Worker 脚本路径
        this.poolSize = poolSize; // 池中 Worker 的数量
        this.workers = []; // 存储 Worker 实例
        this.taskQueue = []; // 任务队列
        this.activeWorkers = 0; // 当前活跃的 Worker 数量
        this.completedTasks = 0; // 已完成的任务数量
        this.onAllTasksComplete = onAllTasksComplete; // 所有任务完成时的回调
        this.onTaskComplete = onTaskComplete; // 每个任务完成时的回调

        // 初始化 Worker 池
        for (let i = 0; i < poolSize; i++) {
            try {
                this.workers.push(this.createWorker());
            } catch (error) {
                console.error('worker数量上限： ', i);
                break;
            }
        }
    }

    // 创建一个新的 Worker 并设置消息处理
    createWorker() {
        const worker = new Worker(this.workerScript);
        worker.onmessage = event => {
            this.activeWorkers--; // 减少活跃 Worker 计数
            this.completedTasks++; // 增加已完成任务计数
            if (this.onTaskComplete) {
                this.onTaskComplete(event.data); // 调用任务完成回调
            }
            this.runNextTask(); // 运行下一个任务
            this.checkAllTasksComplete(); // 检查所有任务是否完成
        };
        return worker;
    }

    // 添加任务到队列并尝试运行
    addTask(taskData) {
        this.taskQueue.push({ taskData }); // 将任务数据添加到队列
        this.runNextTask(); // 尝试运行下一个任务
    }

    // 运行下一个任务
    runNextTask() {
        if (this.taskQueue.length > 0 && this.activeWorkers < this.poolSize) {
            const { taskData } = this.taskQueue.shift(); // 从队列中取出任务
            const worker = this.workers[this.activeWorkers]; // 获取可用的 Worker
            this.activeWorkers++; // 增加活跃 Worker 计数
            worker.postMessage(taskData); // 向 Worker 发送任务数据
        }
    }

    // 检查所有任务是否完成
    checkAllTasksComplete() {
        if (this.taskQueue.length === 0 && this.activeWorkers === 0 && this.completedTasks > 0) {
            this.onAllTasksComplete(); // 调用所有任务完成回调
            this.clear();
        }
    }
    clear() {
        this.taskQueue = [];
        this.completedTasks = 0;
        this.workers.forEach(worker => {
            worker.terminate();
        });
        this.workers = [];
    }
}

export default FJWorkerPool;
